<template>
  <v-container fluid class="auth-container" v-if="checkEvent.success">
    <router-view></router-view>
  </v-container>

  <v-container
    fluid
    class="auth-container"
    v-else-if="checkEvent.success == false"
  >
    <EventNotFound />
  </v-container>

  <v-container fluid class="auth-container" v-else>
    <Loading />
  </v-container>
</template>

<script>
import EventNotFound from '@/containers/Errors/EventNotFound';
import { mapGetters } from 'vuex';
import Loading from '@/containers/Errors/Loading';

export default {
  name: 'AuthLayout',
  components: {
    EventNotFound,
    Loading
  },
  computed: {
    ...mapGetters({
      checkEvent: 'getStatusCheckEvent'
    })
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/devices.scss';
.auth-container {
  position: relative;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  height: 50px;
}

@include mobile {
  .footer-fixed {
    position: unset !important;
    bottom: 0;
    height: 50px;
  }
}
</style>
